import React, { useCallback, useState, useRef, useEffect } from "react";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import "./PageZero.css";
import { useTranslation } from 'react-multi-lang';
import { useDispatch } from "react-redux";

const PageZero = ({ onButtonClick, getMotifSelect,client,setMotifSelect }) => {
  const t = useTranslation();
  console.log("ici")

  const [motifSelect, setMotifSelectLocal] = React.useState(getMotifSelect);


  const [optionMotif] = React.useState([
     {
      value: 1,
      label: "Date péremption proche/Périmé",
    }, {
      value: 2,
      label: "Livraison ou documentation manquante",
    }, {
      value: 3,
      label: "Défaut qualité produit",
    }, 
    {
      value: 4,
      label: "Autre",
    },
  ]);

  
  useEffect(() => {
   
  }, []);

  return (
    <main
      className="pt5 black-80 center"
      style={{ maxWidth: "50%", maxHeight: "30%", margin: "auto" }}
    >
      <form className="measure">
        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
          <h2 className="text-left font-bold">{t("Reclamation.add")}</h2>
          <Row>
            <Col className="pl-1" md="12">
              <Form.Group id="roleClass">
                <label>Motif* </label>
                <Select
                  placeholder="Motif"
                  className="react-select primary"
                  classNamePrefix="react-select"
                  value={motifSelect}
                  onChange={(value) => {
                    setMotifSelectLocal(value);
                    setMotifSelect(value);
                  }}
                  options={optionMotif}
                />
              </Form.Group>
            </Col>
          </Row>



      
        </fieldset>

        <div>
          <br></br>
          <Button
            className="btn-fill pull-right"
            type="button"
            variant="info" onClick={() => onButtonClick("pagezero")}
          >
            {t("suivant")}
          </Button>
          <br></br>  <br></br>
        </div>
      </form>
    </main>
  );
};

export default PageZero;
